import React from 'react'

const ArrowRight = () => (
  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" />
  </svg>
)

export default ArrowRight
